<template>
  <div class="validate">
    <h1 class="text-center">Grazie per aver scelto un prodotto autentico e certificato.</h1>
    <hr>
    
    <h3  class="text-center">Codice {{ code  }}</h3>

    <div class="d-flex my-4" v-if="loading">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <span class="ms-2">Caricamento in corso</span>
    </div>


    <div v-if="validation_response" :class="'mt-4 alert text-center ' + ( validation_response.success ? 'alert-success' : 'alert-danger')"  v-html="validation_response.message"></div>


    <div class="container mb-4">
      <div class="row">
        <div class="col-6 text-center">
          <img src="../assets/images/logo-barriera-1.png" class="img-fluid w-50">
        </div>
        <div class="col-6 text-center">
          <img src="../assets/images/logo-barriera-2.png" class="img-fluid w-50">
        </div>
      </div>

      <div class="row">
        <div class="col-md-8 offset-md-2 py-5 text-center">
          <p>Questo sistema di validazione univoca garantisce che il prodotto provenga da una filiera controllata e rispetti normative ed elevati standard di qualità, sicurezza e tracciabilità.</p>
          <p>Scegliere l’originale significa valorizzare il lavoro, la cura e l’innovazione che contraddistinguono l’eccellenza italiana.</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src

import CmMixin from '../../../webapp/src/mixins/CmMixin'
// import CmMixin from '../mixins/CmMixin'

export default {
  mixins: [ CmMixin ],
  name: 'Validate',
  props: {
    id: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    }
  },
  data: () => {
		return {
      loading: false,
      validation_response: null,
			
		}
	},
  mounted: function(){

    this.validateWarranty();
  },
  methods:{



    validateWarranty: function( callback ){
       
      var self = this;

      var post_data = {
        id: this.id,
        code: this.code
      };
    
      self.loading = true;
      this.api.post( 'warranty/validateWarranty', post_data )
      .then(function (response) {

          self.validation_response = response.data;

          
          if( typeof callback === 'function')
            callback();
      })
      .catch(function (error) {
          self.notification.error(error);
      })
      .finally( function(){
        self.loading = false;
      });
    
    },

  },
  computed:{
    
  }
  
}
</script>
